import React from 'react';
import './About.css';


const About = () => {
  return (

    <>
    <div className="about-us">
      <header className="about-us-header">
        <h1>About Us</h1>
      </header>
      <section className="about-us-content">
        <h2>Welcome to Luxurious Sofa Furniture!</h2>
        <p>
          At Luxurious Sofa Furniture, we believe that your home is a reflection of your personality, 
          and every piece of furniture should add to the charm and comfort of your living space. 
          Since our inception in 2020, we have been dedicated to providing top-notch sofa repair and 
          restoration services, ensuring your beloved furniture pieces continue to enhance your home for years to come.
        </p>

        <h3>Our Story</h3>
        <p>
          Our journey began with a simple mission: to breathe new life into old furniture. Over the years, we've grown from 
          a small, local business to a trusted name in sofa repair, known for our commitment to quality craftsmanship and customer satisfaction. 
          We take pride in our ability to transform worn-out sofas into stunning, functional pieces that our clients can cherish.
        </p>

        <h3>Our Services</h3>
        <ul>
          <li>Reupholstery: Give your sofa a fresh look with our premium fabric and leather options.</li>
          <li>Cushion Replacement: Restore comfort with new, high-quality cushions.</li>
          <li>Frame Repair: Strengthen and stabilize your sofa’s structure.</li>
          <li>Custom Modifications: Tailor your furniture to fit your evolving needs and style.</li>
        </ul>

        <h3>Why Choose Us?</h3>
        <ul>
          <li>Experience: With over 1000 satisfied customers, we have a proven track record of excellence.</li>
          <li>Quality: We use the best materials and craftsmanship to ensure durable, beautiful results.</li>
          <li>Customer Focus: Your satisfaction is our top priority. We listen to your needs and work closely with you to achieve your vision.</li>
          <li>Eco-Friendly: By repairing and restoring your furniture, we help reduce waste and promote sustainability.</li>
        </ul>

        <h3>Meet Our Team</h3>
        <p>
          Our team is comprised of passionate professionals who are dedicated to their craft. From our talented upholsterers to our friendly 
          customer service representatives, every member of Luxurious Furniture is committed to delivering exceptional service and quality results.
        </p>

        <h3>Contact Us</h3>
        <p>
          Have a question or need a quote? Feel free to reach out! We’re always here to help and provide expert advice on all your sofa repair needs.
        </p>
      </section>
    </div>
    </>
  );
};

export default About;
